module.exports = __webpack_public_path__ + "static/img/icon_advantage_title.e55a405.png";


//////////////////
// WEBPACK FOOTER
// ./src/projects/hsbpc/views/welcome/components/img/icon_advantage_title.png
// module id = TkUa
// module chunks = 1